// Re-export the Header component from the JSX file
export { default } from "./Header.jsx";
